import { useCallback } from 'react';

import ClickCollectApi from 'libs/api/admin/clickCollect';
import { useApi } from 'hooks/useApi';

const api = new ClickCollectApi();

/**
 *
 * @returns {{
 *  data: any,
 *  loading: boolean,
 * }} state and callbacks for ClickCollect page
 */
const useClickCollect = () => {
  const { loading, data } = useApi({
    resourceKey: 'records',
    api,
    isMainPage: true,
  });

  const openLinkInNewTab = useCallback((id) => {
    return async () => {
      const {
        data: { url },
      } = await api.redirectToShoppingCenter(id);
      window.open(url, '_blank');
    };
  }, []);

  return {
    data,
    loading,
    openLinkInNewTab,
  };
};

export default useClickCollect;
